/*
 * Copyright 2024 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-wallet/blob/master/LICENSE.md
 */
package org.mifospay.core.data.util

internal val SAMPLE_CURRENCY = """
    [
      {
        "countryName": "United States",
        "currencyCode": "USD",
        "currencySymbol": "${'$'}"
      },
      {
        "countryName": "European Union",
        "currencyCode": "EUR",
        "currencySymbol": "€"
      },
      {
        "countryName": "Japan",
        "currencyCode": "JPY",
        "currencySymbol": "¥"
      },
      {
        "countryName": "United Kingdom",
        "currencyCode": "GBP",
        "currencySymbol": "£"
      },
      {
        "countryName": "China",
        "currencyCode": "CNY",
        "currencySymbol": "¥"
      },
      {
        "countryName": "Switzerland",
        "currencyCode": "CHF",
        "currencySymbol": "CHF"
      },
      {
        "countryName": "Canada",
        "currencyCode": "CAD",
        "currencySymbol": "${'$'}"
      },
      {
        "countryName": "Australia",
        "currencyCode": "AUD",
        "currencySymbol": "${'$'}"
      },
      {
        "countryName": "India",
        "currencyCode": "INR",
        "currencySymbol": "₹"
      },
      {
        "countryName": "Brazil",
        "currencyCode": "BRL",
        "currencySymbol": "R${'$'}"
      },
      {
        "countryName": "South Korea",
        "currencyCode": "KRW",
        "currencySymbol": "₩"
      },
      {
        "countryName": "Russia",
        "currencyCode": "RUB",
        "currencySymbol": "₽"
      },
      {
        "countryName": "Mexico",
        "currencyCode": "MXN",
        "currencySymbol": "${'$'}"
      },
      {
        "countryName": "Singapore",
        "currencyCode": "SGD",
        "currencySymbol": "${'$'}"
      },
      {
        "countryName": "Sweden",
        "currencyCode": "SEK",
        "currencySymbol": "kr"
      },
      {
        "countryName": "Norway",
        "currencyCode": "NOK",
        "currencySymbol": "kr"
      },
      {
        "countryName": "Denmark",
        "currencyCode": "DKK",
        "currencySymbol": "kr"
      },
      {
        "countryName": "Saudi Arabia",
        "currencyCode": "SAR",
        "currencySymbol": "﷼"
      },
      {
        "countryName": "United Arab Emirates",
        "currencyCode": "AED",
        "currencySymbol": "د.إ"
      },
      {
        "countryName": "Turkey",
        "currencyCode": "TRY",
        "currencySymbol": "₺"
      },
      {
        "countryName": "South Africa",
        "currencyCode": "ZAR",
        "currencySymbol": "R"
      },
      {
        "countryName": "Israel",
        "currencyCode": "ILS",
        "currencySymbol": "₪"
      },
      {
        "countryName": "Poland",
        "currencyCode": "PLN",
        "currencySymbol": "zł"
      },
      {
        "countryName": "Hungary",
        "currencyCode": "HUF",
        "currencySymbol": "Ft"
      },
      {
        "countryName": "Czech Republic",
        "currencyCode": "CZK",
        "currencySymbol": "Kč"
      },
      {
        "countryName": "Thailand",
        "currencyCode": "THB",
        "currencySymbol": "฿"
      },
      {
        "countryName": "Malaysia",
        "currencyCode": "MYR",
        "currencySymbol": "RM"
      },
      {
        "countryName": "Indonesia",
        "currencyCode": "IDR",
        "currencySymbol": "Rp"
      },
      {
        "countryName": "Argentina",
        "currencyCode": "ARS",
        "currencySymbol": "${'$'}"
      }
    ]
""".trimIndent()
